import { browser } from '$app/environment';
import { cfgPosthog } from '@infinitro/config';
import { runWhenIdle } from './helpers/idle';
export const MAX_PENDING_CAPTURES = 100;
const POSTHOG_API_KEY = cfgPosthog();
const isEnabled = browser && !!POSTHOG_API_KEY;
let client = null;
const pendingCaptures = [];
const loadPosthog = async () => {
    try {
        const { default: posthogClient } = await import('posthog-js');
        posthogClient.init(POSTHOG_API_KEY, {
            api_host: 'https://posthog.flush.com',
            ui_host: 'https://app.posthog.com',
            capture_pageview: false,
            capture_pageleave: false
        });
        client = posthogClient;
        pendingCaptures
            .splice(0)
            .forEach(([event, properties]) => posthogClient.capture(event, properties));
    }
    catch (error) {
        console.warn('[analytics] posthog failed to load', error);
    }
};
export const initAnalytics = () => {
    if (!isEnabled)
        return;
    runWhenIdle(loadPosthog);
};
/** Queues events until posthog-js has downloaded, so it never weighs on the first paint. */
export const posthog = {
    capture(event, properties) {
        if (client) {
            client.capture(event, properties);
            return;
        }
        if (!isEnabled)
            return;
        if (pendingCaptures.length >= MAX_PENDING_CAPTURES)
            pendingCaptures.shift();
        pendingCaptures.push([event, properties]);
    }
};
